<template>
    <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
            <template v-for="crumb in breadcrumbs" >
                <li :key="crumb.name">
                    <router-link :to="crumb.path">
                        {{ crumb.name }}
                    </router-link>
                </li>
            </template>
        </ul>
    </nav>
</template>

<script>

    const createBreadcrumbs = (vue) => {
        const route = vue.$route;
        const path = route.path;
        const paths = path.split('/');
        vue.breadcrumbs = [];
        while(paths.length > 0) {
            const currentPath = paths.join('/');
            const breadcrumb = vue.getBreadcrumb(currentPath);
            vue.breadcrumbs.unshift(breadcrumb);
            paths.pop();
        }
    }
    
    export default {
        data() {
            return {
                breadcrumbs: []
            }
        },
        methods: {
            getBreadcrumb: (path) => {
                const routes = path.split('/');
                const name = routes[routes.length - 1];
                return {
                    name,
                    path,
                }
            },
        },
        watch: {
            '$route'(newValue, oldValue) {
                createBreadcrumbs(this);
            },
        },
        mounted() {
            createBreadcrumbs(this);
        }
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/common/BaseBreadCrumb.vue